import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeCurrencySettingsRoot } from '@/routers/routes/mainRoutes/routeSettings/currencyRoutes.ts'

import { routeAccountsRoot } from './accountsRoutes'
import { routeCostCenterRoot } from './costCenterRoutes'
import { routeDatevMasterDataRoot } from './datevMasterDataRoutes'
import { routeDunningPlanRoot } from './dunningPlanRoutes'
import { routeDunningTypesRoot } from './dunningTypesRoutes'
import { routeManagementReportRowsRoot } from './managementReportRowRoutes'
import { routeManagementReportSummaryRowsRoot } from './managementReportSummaryRowRoutes'
import { routePaymentTermsHome, routePaymentTermsRoot } from './paymentTermsRoutes'
import { routePaymentTermsTemplatesRoot } from './paymentTermsTemplatesRoutes'
import { routeVatReturnRowsRoot } from './vatReturnRowRoutes'

const routeAccountingSettingsHome: RouteRecordRaw = routePaymentTermsHome

const routeAccountingSettingsRoot: RouteRecordRaw = {
  children: [
    routeAccountingSettingsHome,
    routeDunningTypesRoot,
    routeDunningPlanRoot,
    routePaymentTermsRoot,
    routePaymentTermsTemplatesRoot,
    routeAccountsRoot,
    routeCostCenterRoot,
    routeCurrencySettingsRoot,
    routeDatevMasterDataRoot,
    routeManagementReportRowsRoot,
    routeManagementReportSummaryRowsRoot,
    routeVatReturnRowsRoot,
  ],
  path: 'accounting',
}

const redirectAccountingSettings: RedirectRouteRelative = {
  name: routeAccountingSettingsHome.name,
}

export { redirectAccountingSettings, routeAccountingSettingsHome, routeAccountingSettingsRoot }
